import {auth} from './middleware';
const ImageAnalystRoutes = [
	{
		name: 'ImageAnalystResultsList',
		path: 'results',
		component: () => import('@/components/image-analyst/results/imageAnalystResultList.vue'),
		meta: { middleware: [ auth ] },
	},
	{
		name: 'ImageAnalystResultsSingle',
		path: 'results/:id/view',
		component: () => import('@/components/image-analyst/results/imageAnalystResultSingle.vue'),
		meta: { middleware: [ auth ] }
	},
	{
		name: 'proccessActiveConsole',
		path: 'proccess-console',
		component: () => import('@/components/image-analyst/queue/proccessActiveConsole.vue'),
		meta: { middleware: [ auth ] }
	}
	
]


export default ImageAnalystRoutes;

